
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portable-power-station-calculator",
      function () {
        return require("private-next-pages/portable-power-station-calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portable-power-station-calculator"])
      });
    }
  